import { useEffect, useState } from "react"
import { useNavigate } from "react-router-dom"
import MTable from "../../components/mtable"
import { api } from "../../env"
import { getStorage, STORAGE } from "../../utils/storage"
import { date } from "../../utils/date"
import CreateCompanyProgram from "../admin/companies/programs/CreateCompanyProgram"

export default function Programs() {

    const navigate = useNavigate()
    const companyId = getStorage(STORAGE.COMPANY_ID)

    const [company, setCompany] = useState(null)
    const [isCreate, setIsCreate] = useState(false)
    const onClose = () => {
        setIsCreate(false)
        fetchCompany()
    }

    const fetchCompany = () => api.get(`companies/${companyId}`).then(res => setCompany(res.data))

    useEffect(() => { fetchCompany() }, [companyId])

    useEffect(() => {
        let isCreateSaved = getStorage(STORAGE.CREATE_PROGRAM_STEP)
        if (isCreateSaved) setIsCreate(true)
    }, [])

    const remaining = company ? company.programsQuota - company.totalPrograms : null

    const mapper = {columns: [
        {
            label: "",
            render: (item) => (
                <div className="mw-0">
                    <p className="card-title medium ellipsis" style={{width: '400px'}}>{item.name}</p>
                    <p className="card-label neutral v-spacer-s flex gap-xs" style={{width: '400px'}}>
                        <span className="ellipsis">{item?.tracks?.join(', ') ?? 'No Tracks'}</span>
                        {item.createdAt && <span className="no-wrap" style={{flexShrink: 0}}>{`• ${date(item.createdAt)}`}</span>}
                    </p>
                    <div className="flex center gap-s">
                        <div>
                            <p className="card-title">{item?.mentorCount ?? 0}</p>
                            <p className="card-label-s">Mentors</p>
                        </div>
                        <div>
                            <p className="card-title">{item?.menteeCount ?? 0}</p>
                            <p className="card-label-s">Mentees</p>
                        </div>
                        <div>
                            <p className="card-title">{item?.activePairsCount ?? 0}</p>
                            <p className="card-label-s">Pairs</p>
                        </div>
                    </div>
                </div>
            )
        }
    ]}

    const details = (program) => navigate(program.id)

    return(
        <div className="standard-padding page-xl-centered showing">
            <div className="flex space-between center gap-xs v-spacer-m">
                <p className="section-title">{isCreate ? 'Create Program' : 'Programs'}</p>
                {!isCreate && remaining > 0 && <button className="text" onClick={() => setIsCreate(true)}>Create</button>}
            </div>
            {!isCreate && company && (
                <div className="card flex columns gap-s v-spacer-s">
                    <p className="card-title">Programs Quota</p>
                    <div className="flex columns gap-xs">
                        <p className="card-body">Total: <span className="medium">{company.programsQuota}</span></p>
                        <p className="card-body">Used: <span className="medium">{company.totalPrograms}</span></p>
                        <p className="card-body accent">Remaining: <span className="medium">{remaining}</span></p>
                    </div>
                    {remaining === 0 && <p className="card-label neutral">You have reached your program limit. Contact your administrator to increase the quota.</p>}
                </div>
            )}
            {!isCreate && <MTable path={`companies/${companyId}/programs`} cardView={true} cardViewSettings={{minWidth: '400px'}} onClick={details} mapper={mapper}/>}
            {isCreate && <CreateCompanyProgram companyId={companyId} close={onClose} questionnaireBasePath="/manager/questionnaires"/>}
        </div>
    )
}
